import { renderer as button } from './blocks/button';
import { renderer as category_carousel } from './blocks/categoryCarousel';
import { renderer as content_tiles } from './blocks/contentTiles';
import { renderer as copy_block } from './blocks/copyBlock';
import { renderer as department_hero_banner } from './blocks/departmentHeroBanner';
import { renderer as hero_banner } from './blocks/heroBanner';
import { renderer as masonry_carousel } from './blocks/masonryCarousel';
import { renderer as partner_block } from './blocks/partnerBlock';
import { renderer as preview_error } from './blocks/previewError';
import { renderer as product_carousel } from './blocks/productCarousel';
import { renderer as product_carousel_recommendations } from './blocks/productCarouselRecommendations';
import { renderer as section_title } from './blocks/sectionTitle';
import { renderer as standard_banner } from './blocks/standardBanner';
import { renderer as tile_carousel } from './blocks/tileCarousel';
import { renderer as video_block } from './blocks/videoBlock';

export const renderers = {
  button,
  category_carousel,
  content_tiles,
  copy_block,
  department_hero_banner,
  hero_banner,
  masonry_carousel,
  partner_block,
  preview_error,
  product_carousel,
  product_carousel_recommendations,
  section_title,
  standard_banner,
  tile_carousel,
  video_block,
};

export type ContentBlockRendererType = keyof typeof renderers;
